<template>
  <div :class="$style.container"
       id="institutions"
       style="height: 100%"
       v-loading.fullscreen.lock.body="loading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-row style="border-bottom:2px dotted #e7eaec;padding-bottom: 10px;">
      <el-col :span="20" style="font-weight: bold;line-height: 36px;font-size: 22px">
        用户修改日志
      </el-col>
      <el-col :span="4">

      </el-col>
    </el-row>
    <el-row style="border-bottom: 2px dotted rgb(231, 234, 236)">
      <el-row style="margin-top:20px;">
        <el-col :span="12">
          <el-form ref="form">
            <el-form-item>
             <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                    姓名</span>
              <el-input v-model="alias" placeholder="请输入姓名" style="width:calc(100% - 120px)"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form ref="form">
            <el-form-item>
             <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                    工号</span>
              <el-input v-model="employee_code" placeholder="请输入工号"
                        style="width:calc(100% - 120px)"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form ref="form">
            <el-form-item>
             <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                    手机号</span>
              <el-input v-model="phone" placeholder="请输入手机号"
                        style="width:calc(100% - 120px)"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row style="margin-bottom:20px;">
        <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
        <el-button type="danger" size="small" @click.stop="eventReset">重置</el-button>
      </el-row>
    </el-row>
    <el-table
            :data="tableData"
            :header-cell-style="{'color':'black','font-size':'15px'}"
            border
            style="width: 100%;margin-top: 20px"
            stripe>
      <el-table-column
              fixed
              align="center"
              type="index"
              label="序号"
              width="60">
      </el-table-column>
      <el-table-column
              min-width="200"
              prop="alias"
              sortable
              label="姓名">
      </el-table-column>
      <el-table-column
              min-width="200"
              prop="employee_code"
              sortable
              label="工号">
      </el-table-column>
      <el-table-column
              min-width="200"
              prop="phone"
              sortable
              label="手机号">
      </el-table-column>
      <el-table-column
              min-width="200"
              prop="timestamp"
              sortable
              label="修改时间">
      </el-table-column>

      <el-table-column
              min-width="80"
              label="详情"
      >
        <template slot-scope="scope">
          <div style="text-align: center;width: 100%;height: 100%">
            <el-button
                    style="display: inline-block"
                    type="warning" size="small"
                    @click="handleDetail(scope.row)">详情
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-col style="margin-bottom: 20px">
      <pagination :page="page" @changePage="changePageClick"></pagination>
    </el-col>


    <el-dialog
            :visible.sync="dialogVisible"
            width="700px"
            :show-close="false"
            title="详情"
            style="vertical-align: center; :#FFF9F3 "
            custom-class="dialogSty"
    >
      <div  style="overflow: hidden; height: 500px;  overflow-y:auto;" >
        <div v-for="(item,value) in dataArray" style="width: 100%;">
          <div style="border-radius : 4px ;background-color: #ecf3fc">
            <el-row :gutter="24" style="padding: 20px">
              <el-col :span="10"><div style=" padding-left: 15px;  color: #1d1e1f; font-size: 18px; text-align:left; font-weight:bold" >修改人:{{item.alias}}</div></el-col>
              <el-col :span="14"><div style="font-size: 16px; text-align: left" >修改时间: {{item.modified_date}}</div></el-col>
            </el-row>

            <div style="width: 90%; margin-left: 5%; background-color:  #f6f7fa; border-radius : 4px ;">
              <div style="font-size: 16px;display: flex;justify-content:space-between;  padding-top: 20px">
                <div style=" font-weight:bold;padding-left: 5px; padding-right: 5px;width: 33%; font-size: 16px; min-height: 20px; text-align: center">字段名</div>
                <div style=" font-weight:bold;padding-left: 5px; padding-right: 5px; width: 33%;font-size: 16px; min-height: 20px; text-align: center">修改前</div>
                <div style=" font-weight:bold;padding-left: 5px; padding-right: 5px; width: 33%; font-size: 16px; min-height: 20px; text-align: center">修改后</div>
              </div>
              <div v-for="(sitem,value) in item.data" style="font-size: 16px;display: flex;justify-content:space-between; margin-top: 20px ">

                <div style="padding-left: 5px; padding-right: 5px;width: 33%; font-size: 16px; min-height: 20px; text-align: center">{{sitem.title}}</div>
                <div style="padding-left: 5px; padding-right: 5px;  width: 33%;font-size: 16px; min-height: 20px; text-align: center">{{sitem.before}}</div>
                <div style="padding-left: 5px; padding-right: 5px; width: 33%; font-size: 16px; min-height: 20px; text-align: center">{{sitem.after}}</div>

              </div>
              <div style="height: 20px"></div>
            </div>
            <div style="height: 20px"></div>



          </div>
        </div>
      </div>
    </el-dialog>
  </div>

</template>


<script>
  import http from '../../../APIService/http'
  import pagination from '../../../components/pagination'
  import 'quill/dist/quill.snow.css'
  import * as Quill from 'quill' //引入编辑器
  import moment from 'moment'
  import Video from './video.js'

  Quill.register(Video, true)

  export default {
    data () {
      return {
        dataArray : [],
        dialogVisible : false,
        alias: '',
        employee_code: '',
        phone: '',
        tableData: [],
        loading: false,
        page: {
          current: 1,
          size: 5,
          total: 0,
        },
      }
    },
    name: 'index',
    components: {
      pagination,
    },
    created () {
      debugger
      this.getUserChangeList('', '', '', true)
    },
    methods: {
      handleDetail(row){
        debugger
        this.getUserChangeInfo(row.user_id,row.tenant_id);

      },

      handleClose(done) {
        this.dialogVisible = false
        // this.$confirm('确认关闭？')
        //     .then(_ => {
        //         done();
        //     })
        //     .catch(_ => {});
        done();
        // this.$forceUpdate()
      },
      // 改变页码信息
      changePageClick (page, size) {
        if (page) {
          this.page.current = page
        }
        if (size) {
          this.page.size = size
        }
        this.getUserChangeList(this.alias, this.employee_code, this.phone, false)
      },
      handleQueryClick () {
        this.getUserChangeList(this.alias, this.employee_code, this.phone, true)
      },
      eventReset () {
        this.alias = ''
        this.employee_code = ''
        this.phone = ''
      },
      async getUserChangeList (alias, employee_code, phone,is) {
        let loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })

        if (is) {
          this.page.current = 1
        }

        try {
          let user = this.$store.getters.getUser
          let params = {
            tenant_id: user.tenant_id,
            alias: alias,
            employee_code: employee_code,
            phone: phone,
            offset: this.page.size,
            page: this.page.current - 1,
          }


          debugger
          await http.post('/wapi/log/getUserChangeList', params).then((res) => {
            debugger
            if (res.success) {
              this.tableData = res.data
              this.page.total = Number(res.allCount)
            }
            loading.close()
          })
        } catch (e) {
          loading.close()
          console.log(e)
          debugger
          return e
        }
      },
      async getUserChangeInfo (user_id, tenant_id) {
        let loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })

        try {
          let params = {
            tenant_id:tenant_id,
            user_id: user_id,
          }


          debugger
          await http.post('/wapi/log/getUserChangeInfo', params).then((res) => {
            debugger
            if (res.success) {
              this.dataArray = res.data

              for (let i = 0; i < this.dataArray.length; i++) {
                let obj = this.dataArray[i];
                obj.data = []
                for (let j = 0; j < obj.after.length; j++) {
                  let afterObj = obj.after[j]
                  let beforeObj = obj.before[j]
                  obj.data.push({title:beforeObj.title, after :afterObj.value,  before :beforeObj.value})

                }
              }
            }
            this.dialogVisible = true
            loading.close()
          })
        } catch (e) {
          loading.close()
          console.log(e)
          debugger
          return e
        }
      },
    }
  }
</script>

<style lang="scss" module>
  .el-container {
    padding: 20px;
    background: white;
    height: 100%;
  }

  #jurisdictionActive {
    background: white;
  }

  #jurisdictionActive .el-main {
    background: white;
  }

  .el-main {
    background: white;
    /*border: 1px solid #DCDFE6;*/
    border-left: none;
    padding: 20px 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
  }

  /*输入框背景*/
  #productSku .sWei .el-input__inner {
    background: #eee;
  }
</style>



// WEBPACK FOOTER //
// src/pages/system/components/log_tab1.vue